module.exports = __webpack_public_path__ + "img/fixed.630f808e.png";